<template>
  <content-dialog
    :visible.sync="modalVisible"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    max-width="500px"
    :title-padding="$vuetify.breakpoint.xsOnly ? 'pa-2' : 'pa-4'"
  >
    <!--<editor-fold desc="Dialog Title">-->
    <template v-slot:dialogTitle>
      Add Work Log
    </template>
    <!--</editor-fold>-->

    <!--<editor-fold desc="Dialog Content">-->
    <v-card-text :class="{'pa-4': $vuetify.breakpoint.smAndUp }">
      <validation-observer ref="validationObserver">
        <validation-provider
          v-slot="{ errors }"
          rules="required|min_value:0.1"
          name="hours spent"
        >
          <v-text-field
            v-model="hoursSpentDirty"
            v-validate="'required|min_value:0.1'"
            :error-messages="errors"
            type="number"
            step="0.5"
            min="0"
            label="Hours Spent"
            placeholder="Enter hours spent..."
            outlined
          />
        </validation-provider>

        <validation-provider
          v-slot="{ errors }"
          rules="required"
          name="work done by"
        >
          <assignee-modal-select
            v-model="assignedToDirty"
            v-validate="'required'"
            :dialog-visible.sync="assigneeModalSelectVisible"
            :error-messages="errors"
            multiple
            outlined
            clearable
            small-chips
            deletable-chips
            label="Work Done By"
            @submit="assigneeModalSelectVisible = false"
          />
        </validation-provider>
      </validation-observer>
    </v-card-text>
    <!--</editor-fold>-->

    <!--<editor-fold desc="Dialog Actions">-->
    <template slot="dialogActions">
      <v-spacer />
      <v-btn
        text
        color="grey"
        @click="modalVisible = false"
      >
        Cancel
      </v-btn>
      <v-btn
        color="primary"
        :loading="submitting"
        @click="submit()"
      >
        <v-icon
          small
          left
        >
          check
        </v-icon>
        Save Work For Today
      </v-btn>
    </template>
    <!--</editor-fold>-->
  </content-dialog>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'
import ServiceTask from '@/models/ServiceTask'
import ContentDialog from '@/components/helpers/Dialog'
import AssigneeModalSelect from '@/components/service/helpers/AssigneeModalSelect'
import validationScrollMixin from '@/mixins/validationScrollMixin'

export default {
    name: 'ServiceTaskAddWorkLogDialog',
    components: {
      AssigneeModalSelect,
      ContentDialog
    },
    mixins: [
      validationScrollMixin
    ],
    props: {
      visible: Boolean,
      serviceTask: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        assigneeModalSelectVisible: false,
        hoursSpentDirty: null,
        assignedToDirty: [],
        submitting: false
      }
    },
    computed: {
      modalVisible: {
        get: function () {
          return this.visible
        },
        set: function (value) {
          this.$emit('update:visible', value)
        }
      },
      currentEmployee() {
        return this.$store.state.auth.user.staff
      }
    },
    mounted() {
      this.pushCurrentEmployee()
    },
    methods: {
      async submit() {
        let validate = await this.$refs.validationObserver.validate()

        if (!validate) {
          this.showAlertAndScrollToFirstError()
          return
        }

        this.submitting = true

        try {
          await ServiceTask.api.addWorkLog(this.serviceTask.id, {
            hours_spent: this.hoursSpentDirty,
            assigned_to: this.assignedToDirty.map(assignee => {
              return {
                type: assignee.type,
                id: assignee.id
              }
            })
          })

          this.$emit('serviceTask:updated', this.serviceTask)

          this.$store.dispatch('alert', {
            text: 'Work successfully logged',
            color: 'success'
          })

          this.modalVisible = false

          this.assignedToDirty = []
          this.pushCurrentEmployee()
          this.hoursSpentDirty = null
        } catch (e) {
          this.$store.dispatch('alert', {
            'text': 'Something went wrong',
            'color': 'error'
          })

          throw e
        } finally {
          this.submitting = false
        }
      },
      pushCurrentEmployee() {
        let employee = cloneDeep(this.currentEmployee)
        employee.type = ServiceTask.ASSIGNEE_TYPE_STAFF

        this.assignedToDirty.push(employee)
      }
    }
  }
</script>
